import React, { type JSX } from 'react';

import { HierarchyProps } from './types';
import { TreeViewProviders } from './TreeViewProviders';

export const Hierarchy = (props: HierarchyProps): JSX.Element =>
    props.isLoading ? props.loadingSkeleton ?? <></> : <TreeViewProviders {...props} />;
